import {
  MDBBadge,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBTable,
} from "mdbreact";
import { GenericProducts } from "../../../../../constants";
import {
  packLabel,
  preferredIdOf,
  supplierIdsOf,
  supplierLabel,
  variantsOf,
} from "./common";

const Row = ({ label, children }) => (
  <tr>
    <th className="text-muted small" style={{ width: 160 }}>
      {label}
    </th>
    <td>{children || <span className="text-muted">—</span>}</td>
  </tr>
);

/**
 * Details of a branded product: its generic, tagged suppliers and variants.
 */
export default function ProductView({
  product,
  toggle,
  suppliers = [],
  onEdit,
}) {
  if (!product) return null;

  const generic = GenericProducts.find(product.pgid);
  const preferred = preferredIdOf(product);
  const tagged = supplierIdsOf(product).map(
    (id) => suppliers.find(({ _id }) => _id === id) || { _id: id },
  );

  return (
    <MDBModal isOpen toggle={toggle} backdrop size="lg">
      <MDBModalHeader
        toggle={toggle}
        className="light-blue darken-3 white-text"
      >
        <MDBIcon icon="tag" className="mr-2" />
        {product.name}
      </MDBModalHeader>
      <MDBModalBody>
        <MDBTable small className="mb-3">
          <tbody>
            <Row label="Generic">
              {generic ? (
                <>
                  <code className="mr-1">{generic.abbreviation}</code>
                  <b>{generic.name}</b>
                  <small className="d-block text-muted">
                    {generic.section} · {generic.category} · uom: {generic.uom}
                  </small>
                </>
              ) : (
                <MDBBadge color="warning">No generic</MDBBadge>
              )}
            </Row>
            <Row label="Manufacturer">{product.manufacturer}</Row>
            <Row label="Suppliers">
              {tagged.length > 0 &&
                tagged.map((supplier) => (
                  <MDBBadge
                    key={supplier._id}
                    color={supplier._id === preferred ? "primary" : "light"}
                    className="mr-1 mb-1"
                  >
                    {supplier._id === preferred && (
                      <MDBIcon icon="star" className="mr-1 text-warning" />
                    )}
                    {supplierLabel(supplier)}
                  </MDBBadge>
                ))}
            </Row>
            <Row label="Flags">
              {product.tracksLot && (
                <MDBBadge color="info">Lot &amp; expiry</MDBBadge>
              )}
            </Row>
            <Row label="Description">{product.description}</Row>
            <Row label="Registered">
              {product.createdAt &&
                new Date(product.createdAt).toLocaleString()}
            </Row>
          </tbody>
        </MDBTable>

        <h6 className="mb-1">Variants</h6>
        <MDBTable small bordered className="mb-3">
          <thead className="grey lighten-4">
            <tr>
              <th>Variant</th>
              <th>Packaging</th>
            </tr>
          </thead>
          <tbody>
            {variantsOf(product).map((variant, index) => (
              <tr key={variant._id || index}>
                <td>
                  {product.isDefault && variant.isDefault && (
                    <MDBIcon icon="star" className="text-warning mr-1" />
                  )}
                  <b>{variant.name}</b>
                </td>
                <td>{packLabel(variant, product) || "—"}</td>
              </tr>
            ))}
          </tbody>
        </MDBTable>

        <div className="text-center">
          <MDBBtn
            color="info"
            rounded
            size="sm"
            onClick={() => onEdit(product)}
          >
            <MDBIcon icon="pen" className="mr-1" /> Edit
          </MDBBtn>
        </div>
      </MDBModalBody>
    </MDBModal>
  );
}
